import {strCode} from '../../../consts/strCode';
import {t} from '../../../services/localization/localizationService';
import {twx} from '../../../utils/tailwindUtils';
import AiAssistantCloseCircleIcon from '../../Icons/AiAssistantIcons/AiAssistantCloseCircleIcon';

const AiAssistantCloseButton = ({onClick, className}) => (
    <button
        type='button'
        onClick={onClick}
        aria-label={t(strCode.AI_ASSISTANT_CLOSE_BUTTON)}
        className={twx('shrink-0', className)}
    >
        <AiAssistantCloseCircleIcon className='h-8 w-8' />
    </button>
);

export default AiAssistantCloseButton;
